import { useTranslation } from "features/translations";
import { Action, Heading4, Icon, Paragraph } from "shared/components";

import { useWidgetContent } from "../Content064.context";
import styles from "./MobileCoursesList.module.scss";

export const MobileCoursesList = () => {
  const { t } = useTranslation();
  const { unavailableCourses, onDeleteCourse } = useWidgetContent();

  return unavailableCourses.map(({ id, title, slug }) => (
    <div className={styles.block} key={id}>
      <div>
        <Paragraph color="grey" className={styles.label} appearance="smaller">
          {t("selected_course")}
        </Paragraph>
        <Heading4 color="light">{title}</Heading4>
      </div>
      <Action className={styles.button} onClick={onDeleteCourse(slug)}>
        <Icon name="close_white" />
      </Action>
    </div>
  ));
};
